import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Code, AlertTriangle, HardDrive } from 'lucide-react';
import { useApp } from '../context';

export default function DeveloperSettings() {
  const navigate = useNavigate();
  const { forceStorageFull } = useApp();

  return (
    <div className="bg-[#f8f5f5] min-h-screen pb-32">
      {/* Header */}
      <header className="p-5 flex items-center gap-4 sticky top-0 bg-[#f8f5f5]/80 backdrop-blur-md z-20">
        <button
          onClick={() => navigate(-1)}
          className="size-10 rounded-full hover:bg-slate-200/50 flex items-center justify-center transition-colors shadow-sm bg-white"
        >
          <ArrowLeft size={24} className="text-slate-600" />
        </button>
        <div className="flex items-center gap-3">
          <div className="size-10 rounded-xl bg-purple-100 flex items-center justify-center">
            <Code size={20} className="text-purple-600" />
          </div>
          <h1 className="text-xl font-bold text-slate-900 tracking-tight">Developer Tools</h1>
        </div>
      </header>

      <div className="px-5 space-y-5 mt-4">
        {/* Warning Card */}
        <div className="bg-amber-50 rounded-3xl p-5 border border-amber-200 flex items-start gap-4 shadow-sm">
          <div className="size-10 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center shrink-0 mt-0.5">
            <AlertTriangle size={20} />
          </div>
          <div>
            <h3 className="text-amber-900 font-bold mb-1 leading-tight">Proceed with caution</h3>
            <p className="text-amber-700 text-sm leading-relaxed">
              These settings are intended for development and testing.
            </p>
          </div>
        </div>

        {/* Settings List */}
        <div className="bg-white rounded-[2.5rem] p-6 shadow-sm border border-slate-100 space-y-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="size-12 rounded-2xl bg-red-50 text-red-500 flex items-center justify-center shrink-0">
                <HardDrive size={24} />
              </div>
              <div>
                <p className="font-bold text-slate-900 text-lg">Test Storage Limit</p>
                <p className="text-xs text-slate-500 mt-0.5 max-w-[200px] leading-relaxed">
                  Simulate reaching the 5MB browser quota to preview the warning modal.
                </p>
              </div>
            </div>

            <button
              onClick={forceStorageFull}
              className="px-4 py-2 bg-red-100 hover:bg-red-200 text-red-600 font-bold rounded-xl transition-colors active:scale-95 text-sm shrink-0"
            >
              Trigger Modal
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
